module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Flower#2-4b58983a1fb0ced255b30006f83cd31d1b9617a847fd9edd377f34150b4b2915.svg";